import { configureStore } from '@reduxjs/toolkit'
import homePageReducer from './slice/homepage'
import courseDetailReducer from './slice/courseDetailPage'
import ourPeopleReducer from './slice/ourPeoplePage'
import ourPartnersReducer from './slice/ourPartnersPage'
import ourPeopleTagReducer from './slice/ourPeopleTagPage'
import campusLifeReducer from './slice/campusLifePage'
import campusLifeTabReducer from './slice/campusLifeTabPage'
import allProgrammesReducer from './slice/allProgrammesPage'
import campusLifeAccommodationReducer from './slice/campusLifeAccommodation'
import contactUsPrivacyReducer from './slice/contactUsPrivacyPage'
import scholarshipReducer from './slice/scholarshipsPage'
import scholarshipAssetsReducer from './slice/finAidScholarshipAssetsPage'
import aboutUnitenReducer from './slice/aboutUnitenPage'
import aboutUnitenContentReducer from './slice/aboutUnitenContentPage'
import ourAlumniCommunityReducer from './slice/ourAlumniCommunity'
import unitEnquiresTabReducer from './slice/unitEnquiriesPage'
import academicCalendarReducer from './slice/academicCalendarPage'
import academicCalendarItemsReducer from './slice/academicCalendarItemsPage'
import admissionReducer from './slice/admissionPage'
import internationalOfficeReducer from "./slice/internationalOfficePage"
import faqReducer from "./slice/faqPage"
import researchReducer from "./slice/researchPage"
import researchPagesReducer from "./slice/researchPages"
import vacanciesReducer from "./slice/vacanciesPage"
import eventReducer from "./slice/NewAndEventsPage"
import training from './slice/training'
import courses from './slice/getCourses'
import collegeReducer from './slice/collegePage'
import studentHubPage from './slice/studentHubPage'
import staffHubPage from './slice/staffHubPage'
import kshasReducer from './slice/KSHAS'
import putrajayaReducer from './slice/putrajaya'
import announcementReducer from './slice/announcementPage'
import quickReference from './slice/quickReferencePage'
import quickStaffReference from './slice/quickStaffReferencePage'
import examination from './slice/examinationPage'
import registrar from './slice/registrar'


export const store = configureStore({
    reducer: {
        homepage: homePageReducer,
        courseDetail: courseDetailReducer,
        ourPeople: ourPeopleReducer,
        ourPartners: ourPartnersReducer,
        ourPeopleTag: ourPeopleTagReducer,
        campusLife: campusLifeReducer,
        campusLifeTab: campusLifeTabReducer,
        campusLifeAccommodation: campusLifeAccommodationReducer,
        allProgrammes: allProgrammesReducer,
        scholarships: scholarshipReducer,
        contactUsPrivacy: contactUsPrivacyReducer,
        aboutUniten: aboutUnitenReducer,
        aboutUnitenContent: aboutUnitenContentReducer,
        scholarshipsAssets: scholarshipAssetsReducer,
        ourAlumniCommunity: ourAlumniCommunityReducer,
        unitEnquiresTab: unitEnquiresTabReducer,
        academicCalendar: academicCalendarReducer,
        academicCalendarItems: academicCalendarItemsReducer,
        admission: admissionReducer,
        internationalOffice: internationalOfficeReducer,
        faq: faqReducer,
        research: researchReducer,
        researchPages: researchPagesReducer,
        vacancies: vacanciesReducer,
        events: eventReducer,
        training: training,
        courses: courses,
        college: collegeReducer,
        studentHub: studentHubPage,
        staff: staffHubPage,
        kshasTab: kshasReducer,
        putrajayaTab: putrajayaReducer,
        announcement: announcementReducer,
        quickReference,
        quickStaffReference,
        examination,
        registrar
    }
})